// Auto-generated by robust sync script
export const migrated = {
  le_lien_de_votre_annonce_airbnb_est_obligatoire_:
    "El enlace a su anuncio de Airbnb es obligatorio",
  la_note_airbnb_doit__tre_au_minimum_de_4_5_:
    "La calificación de Airbnb debe ser al menos de 4 a 5.",
  compte_cr______v_rifiez_votre_email_pour_activer_votre_acc_s_au_club_:
    "Crear cuenta revisa tu correo electrónico para activar tu acceso al club",
  club_r_serv__aux_h_tes_airbnb_not_s_4_5__:
    "Club reservado para huéspedes de airbnb no s'4 5",
  comparez_vos_gains_r_els: "Compare sus ganancias reales",
  le_mod_le_traveltrok_est_gagnant_gagnant___le_voya:
    "El mod traveltrok es un ganador, el viajero gana",
  votre_prix_sur_les_autres_sites: "Tu precio en otros sitios",
  diminuer_le_prix: "Reducir el precio",
  augmenter_le_prix: "Aumentar el precio",
  net_pour_vous: "Red para ti",
  de_commissions: "Comisiones",
  prix_pay__par_le_voyageur: "Precio pagado por el viajero",
  revenu___d_clarer__imp_ts_: "Ingresos para declarar impuestos",
  vous_d_clarez_100__du_prix____commissions__:
    "Declaras el 100 de las comisiones de precio",
  de_frais_h_te: "Tarifas de anfitrión",
  __0__compar____booking_: "0 reserva de comparación",
  mod_le_frais_h_te__depuis_25_____:
    "Modifica la tarifa de anfitrión desde el 25",
  vous_d_clarez_100__du_prix_voyageur_:
    "Declaras el 100 del precio del pasajero.",
  strat_gie_gagnante: "Estrategia ganadora",
  prix_voyageur: "Precio viajero",
  _5__pour_le_voyageur: "5 para el viajero",
  le_meilleur_des_deux_mondes: "Lo mejor de ambos mundos",
  avantage_fiscal: "Ventaja fiscal",
  vous_d_clarez_moins__vous_payez_moins_d____imp_ts_:
    "Declaras menos pagas menos impuestos",
  sc_nario___traveltrok_applique_5__de_frais_voyageu:
    "Sc nario traveltrok aplica 5 tarifas de viajero",
  appartement: "Departamento",
  maison: "Hogar",
  inclut_villa_chalet: "Incluye chalet chalet",
  loft: "Desván",
  luxe: "Lujo",
  insolite: "Inusual",
  autre: "Otro",
  campagne: "Campaña",
  mer: "Mar",
  montagne: "Montaña",
  au_dessus_de_500_nuit: "Más de 500€/noche",
  aucun_resultat_dynamique: "Sin resultados dinámicos",
  service_de_localisation_indisponible__r_essayez_da:
    "El servicio de ubicación no está disponible. Vuelve a intentarlo en un momento.",
  quel_type_de_logement_souhaitez_vou:
    "¿Qué tipo de alojamiento quieres ofrecer?",
  choisissez_la_cat_gorie_qui_d_crit_le_mieux_votre_:
    "Elige la categoría que mejor describa tu alojamiento",
  quel_est_le_cadre_du_logement__: "¿Cómo es el entorno de la vivienda?",
  o__est_situ__votre_logement__: "¿Dónde está situado vuestro alojamiento?",
  pays_europ_en_de_r_f_rence: "País europeo de referencia.",
  ville__village__code_postal___: "Ciudad, pueblo, código postal...",
  recherche_en_cours___: "Investigación en progreso...",
  recherche___: "Investigación...",
  localiser: "Localizar",
  nous_utiliserons_cette_adresse_pour_localiser_votr:
    "Utilizaremos esta dirección para localizar su alojamiento.",
  localis_: "Localizado",
  _copy__openstreetmap_france: "© OpenStreetMap Francia",
  emplacement_valid_: "Ubicación validada",
  d_crivez_votre_logement: "Describe tu alojamiento",
  donnez_envie_aux_voyageurs_de_s_journer_chez_vous_:
    "Haz que los viajeros quieran quedarse contigo",
  titre_de_l__annonce: "Título del anuncio",
  ex__charmant_studio_au_c_ur_de_paris:
    "Ej: estudio con encanto en el corazón de París",
  soyez_concis_et_accrocheur: "Sea conciso y pegadizo",
  description_d_taill_e: "Descripción detallada",
  parlez_de_votre_logement__du_quartier__des__quipem:
    "Habla sobre tu alojamiento, el barrio, las comodidades...",
  mentionnez_les_points_forts: "Menciona los puntos fuertes.",
  voyageurs: "Viajeros",
  chambres: "Alojamiento",
  lits: "Camas",
  salles_de_bain: "Baños",
  d_tails_du_logement: "Detalles del alojamiento",
  donnez_plus_d__informations_sur_la_capacit__d__acc:
    "Dar más información sobre la capacidad de recepción",
  surface__m__: "ÁRea (m²)",
  ex__85: "Ej: 85",
  ajoutez_des_photos: "Agregar fotos",
  mettez_en_valeur_votre_logement_avec_de_belles_ima:
    "Resalta tu hogar con bellas imágenes",
  glissez_vos_photos_ici: "Arrastra tus fotos aquí",
  parcourez_vos_fichiers: "Explora tus archivos",
  jpg__png_jusqu____5_mo: "JPG, PNG (hasta 5 MB)",
  d_j__en_ligne: "Ya en línea",
  __uploader: "Para subir",
  fixez_votre_prix: "Establece tu precio",
  vous_pourrez_le_modifier___tout_moment_:
    "Puedes modificarlo en cualquier momento.",
  par_nuit: "Por noche",
  aper_u_de_votre_annonce: "Vista previa de su anuncio",
  titre_de_votre_annonce: "Título de tu anuncio",
  nouveau: "Nuevo",
  localisation: "Ubicación",
  suppression_du_profil__tapez_supprimer_puis_confirmez__si_la_suppression_compl_te_est_impossible__votre_profil_sera_mis_en_pause_et_masque_:
    "Eliminar el tipo de perfil eliminar y luego confirmar si la eliminación completa es imposible, su perfil se pausará y se ocultará.",
  suppression_compl_te_indisponible__profil_mis_en_pause_et_masque_:
    "Completar Eliminar perfil no disponible en pausa y ocultar",
  preferences: "Preferencias",
  gerez_vos_unites__votre_visibilite_et_le_statut_de_votre_profil_:
    "Gestiona tus unidades, tu visibilidad y el estado de tu perfil",
  vous_restez_connecte_mais_vos_annonces_ne_sont_plus_actives_dans_les_suggestions_:
    "Sigues conectado pero tus anuncios ya no están activos en las sugerencias",
  votre_profil_et_vos_logements_ne_remontent_plus_dans_la_carte_et_les_pages_de_destinations_:
    "Tu perfil y tus alojamientos ya no aparecen en el mapa ni en las páginas de destino.",
  base_de_donnees_non_migree__vos_preferences_sont_sauvegardees_localement_pour_l_instant_:
    "La base de datos no se ha migrado. Sus preferencias se guardan localmente por ahora.",
  delai_depasse: "El plazo supera",
  echeance_aujourd__hui: "Vencimiento hoy",
  mois_restants: "Meses restantes",
  nuits_dues_et_aucun_accueil_effectue:
    "Noches debidas y no se ha realizado recepción.",
  suivi_des_echanges: "Seguimiento de los intercambios",
  suivez_les_nuits_dues_dans_les_deux_sens__qui_vous_doit_des_nuits__qui_vous_devez_accueillir__et_le_temps_restant_pour_cl__turer_chaque_echange_:
    "Realice un seguimiento de las noches adeudadas en ambos sentidos, quién le debe, noches a quién le debe y el tiempo restante para cerrar cada intercambio.",
  nom__logement__contrat__dates__statut_des_deux_c_tes_et_temps_restant_:
    "Nombre fechas del contrato de alojamiento estado de ambas partes y tiempo restante",
  visualisez_vos_villes_cibles_et_les_rayons_de_recherche_autour_de_chaque_point_:
    "Visualice sus ciudades objetivo y busque radios alrededor de cada punto",
  __d_couvrir___: "Cubrir",
  les_incontournables___visiter_lors_de_votre_s_jour:
    "Los lugares imprescindibles que visitar durante tu estancia",
  impossible_de_finaliser_la_demande__r_essaie_dans_:
    "No se puede finalizar la solicitud, intente nuevamente en",
  r_server_ton_s_jour___: "Reserva tu estancia",
  parcours_simple_en_3__tapes__recherche__d_tails__v:
    "Búsqueda simple de detalles en 3 pasos v",
  recherche: "Investigación",
  validation: "Validación",
  demande_envoy_e: "Solicitud enviada",
  un_h_te_va_te_r_pondre_rapidement_avec_les_d_tails:
    "Un anfitrión responderá rápidamente con detalles.",
  cr_er_une_nouvelle_demande: "Crear una nueva solicitud",
  "1__ton_s_jour": "1 dia",
  arriv_e: "Llegada",
  pers_: "Gente",
  dates_flexibles: "Fechas flexibles",
  dates_exactes: "Fechas exactas",
  _3_jours: "3 dias",
  _7_jours: "7 dias",
  _14_jours: "14 dias",
  je_voyage_avec_des_animaux: "Viajo con animales",
  "2__infos_r_servation": "2 información de reserva",
  nom_complet: "Nombre completo",
  ex__clara_martin: "Ex clara martin",
  message___l_h_te: "Envía un mensaje al anfitrión",
  pr_sentation_rapide__heure_d_arriv_e__besoins_part:
    "El tiempo de llegada rápido de la presentación necesita parte.",
  "3__validation_de_la_r_servation": "3 validación de la reserva",
  destination: "Destino",
  s_jour: "Permanecer",
  flexibilit_: "Flexibilidad",
  tarification_traveltrok: "Precios de traveltrok",
  frais_plateforme: "Tarifas de plataforma",
  "1eur_voyageur___1eur_h_te": "1su viajero 1su anfitrión",
  incluse: "Incluido",
  total_estim_: "Estimación total",
  continuer: "Continuar",
  envoi___: "Envío",
  confirmer_ma_r_servation: "Confirmar mi reserva",
  r_sum__intelligent: "R suma inteligente",
  prix_base: "Precio base",
  total_actuel: "Total actual",
  inclut_1eur_voyageur___1eur_h_te_par_nuit__assuran:
    "Incluye 1 huésped y 1 huésped por noche asegurado.",
  membres_actifs: "Miembros activos",
  note_moyenne: "Calificación promedio",
  d_couvrez_: "Descubrir",
  points_forts: "Reflejos",
  conseils_pratiques: "Consejos prácticos",
  informations_pratiques: "Información práctica",
  meilleure_saison: "Mejor temporada",
  s_jour_moyen: "Estancia media",
  langue: "Idioma",
  monnaie: "Dinero",
  fuseau_horaire: "Huso horario",
  voir_les_logements: "Ver los alojamientos",
  nous_contacter: "Contáctenos",
  villa: "Villa",
  logements_disponibles___: "Alojamiento disponible",
  annonces___la_nuit_avec_h_tes_v_rifi_s_:
    "Anuncios nocturnos con anfitriones verificados",
  voir_la_carte_des_logements: "Ver el mapa del alojamiento",
  h_te_v_rifi_: "Anfitrión verificado",
  mod_le_traveltrok: "Modifica el traveltrok",
  r_server: "Reservar",
  pas_encore_de_logements_ici: "No hay alojamiento aquí todavía",
  sois_le_premier_h_te___proposer_son_logement___:
    "Sé el primer anfitrión en ofrecer su alojamiento.",
  ajouter_mon_logement: "Añadir mi alojamiento",
  destinations_proches: "Destinos cercanos",
  explorez_d_autres_destinations_en_: "Explora otros destinos en",
  am_rique_du_nord: "América del norte",
  am_rique_du_sud: "Sudamerica",
  oc_anie: "Oceanía",
  afrique: "ÁFrica",
  asie: "Asia",
  europe: "Europa",
  carte_des_destinations: "Mapa de destino",
  destinations_affich_es: "Destinos mostrados",
  continents: "Continentes",
  survolez_un_point_pour_voir_les_d_tails:
    "Pase el cursor sobre un punto para ver los detalles",
  _changes_r_alis_s: "Cambios realizados",
  mes_favoris: "Mis favoritos",
  sauvegard_: "Respaldo",
  tout_effacer: "Borrar todo",
  s_lectionn_: "Selección",
  pour_comparaison: "Para comparar",
  voir_la_comparaison: "Ver la comparación",
  trier_par__: "Ordenar por",
  note: "Nota",
  _changes: "Cambios",
  capacit_: "Capacidad",
  pi_ces: "Piezas",
  type_de_logement: "Tipo de alojamiento",
  effacer: "Para borrar",
  r_initialiser_les_filtres: "R inicializar filtros",
  filtres_actifs__: "Filtros activos",
  aucun_r_sultat: "Sin resultados",
  aucun_favori_ne_correspond___vos_filtres_:
    "Ningún favorito coincide con tus filtros",
  comparaison_des_logements: "Comparación de alojamiento",
  logements_s_lectionn_s: "Alojamientos seleccionados",
  fermer: "Cerca",
  astuce: "Truco",
  utilisez_les_filtres_pour_affiner_vos_favoris_par:
    "Utilice los filtros para refinar sus favoritos por",
  type: "Amable",
  s_lectionnez_ensuite_jusqu______4_logements_pour_l:
    "Luego seleccione hasta 4 espacios para el",
  aucun_sch_ma_conversation_compatible_trouv__:
    "No se encontró mi conversación compatible",
  souhaite_venir_dynamique: "Deseo venir dinámico",
  aimerais_visiter_dynamique: "Me gustaría visitar la dinámica.",
  demande_ignor_e_: "Solicitud ignorada",
  conversation_introuvable_: "Conversación no encontrada",
  impossible_d_ouvrir_la_discussion_pour_le_moment_:
    "No se puede abrir la discusión en este momento.",
  demande_supprim_e_: "Solicitud eliminada",
  bonjour_merci_dynamique: "Hola gracias dinamica",
  demande_supprim_e_avec_un_message_poli_:
    "Solicitud eliminada con un mensaje cortés",
  impossible_de_supprimer_cette_demande_pour_le_mome:
    "No se puede eliminar esta solicitud en este momento",
  demandes_directes: "Solicitudes directas",
  matching_auto: "Quieren venir a tu zona",
  match_r_ciproque: "Partido recíproco",
  carte_secteur: "Tarjeta sectorial",
  toutes: "Todo",
  lik_es: "Apreciado",
  en_discussion: "A discusión",
  ignor_es: "Ignorado",
  sans_date_pr_cise__juste__change_: "Sin fecha específica solo cambio",
  date_pr_cise___dans_les_6_mois: "Fecha específica dentro de los 6 meses",
  date_pr_cise___dans_l_ann_e: "Fecha específica en el año.",
  flexible: "Flexible",
  date_pr_cise: "Fecha especifica",
  dates_identiques: "Mismas fechas",
  dates_compatibles: "Fechas compatibles",
  dates_diff_rentes: "Diferentes fechas",
  dates_inconnues: "Fechas desconocidas",
  souhaite_venir__: "Deseo venir",
  voir_le_logement_cibl_: "Ver alojamiento de destino",
  personnes_int_ress_es_par_votre_secteur: "Personas interesadas en tu sector",
  vert___match_r_ciproque_ville___dates:
    "Fechas de ciudades de partido recíproco verde",
  int_r_t_entrant: "Interés entrante",
  logement_cibl___: "Vivienda dirigida",
  dates__: "Fechas",
  sans_date_pr_cise: "Sin fecha concreta",
  ouvrir_le_chat: "Abrir chat",
  pas_encore_de_points_sur_la_carte: "Aún no hay puntos en el mapa.",
  les_membres_qui_veulent_venir_dans_votre_secteur_a:
    "Miembros que quieran venir a su área para",
  logement_vis_: "Alojamiento dirigido",
  demande: "Pedido",
  message: "Mensaje",
  logement_s_: "Alojamiento(s)",
  annonce_indisponible: "Anuncio no disponible",
  jour_s_: "Días)",
  dur_e___d_finir: "Duración hasta finalizar",
  match_auto: "Coincidencia automática",
  r_ciproque: "Recíproca",
  discuter_dans_la_messagerie: "Chat en mensajería",
  ignorer_la_demande: "Ignorar la solicitud",
  ignorer: "Ignorar",
  supprimer_avec_message_poli: "Eliminar con mensaje cortés",
  poli: "Educado",
  supprimer_sans_message: "Eliminar sin mensaje",
  suppr_: "Borrar",
  aucune_demande_pour_le_moment: "No hay solicitudes por el momento",
  le_tableau_est_pr_t__les_demandes_s_afficheront_ic:
    "El tablero está listo y las solicitudes aparecerán aquí.",
  surface: "Superficie",
  voyagez: "Viajar",
  envie_d___changer_avec_: "Quiere cambiar con",
  proposez_un__change_de_logement_et_d_couvrez_:
    "Proponer una permuta de vivienda y cobertura.",
  gratuitement_: "Gratis",
  voir_la_fiche_du_logement: "Ver la ficha de alojamiento",
  carte_des_logements: "Mapa de viviendas",
  r_sultats_visibles: "Resultados visibles",
  jour: "Día",
  s_lectionn_s: "Seleccionado s",
  printemps: "Primavera",
  _t_: "T",
  automne: "Otoño",
  hiver: "Invierno",
  toute_l__ann_e: "Todo el año",
  bonjour_host_dynamic: "Hola dinámica de anfitrión",
  impossible_de_contacter_cet_h_te____errormessage__:
    "No se puede contactar con este mensaje de error de host",
  impossible_de_contacter_cet_h_te_pour_le_moment_:
    "No se puede contactar con este anfitrión en este momento",
  annonce_introuvable_: "Anuncio no encontrado",
  choisissez_vos_dates_pour_envoyer_la_proposition_:
    "Elige tus fechas para enviar la propuesta",
  la_date_de_d_part_doit__tre_post_rieure___la_date_:
    "La fecha de salida debe ser posterior a la fecha de llegada.",
  proposition_d__change_avec_dates_pr_cises:
    "Propuesta de intercambio con fechas concretas",
  __logement_cibl_: "Vivienda dirigida",
  __ville: "Ciudad",
  __arriv_e_souhait_e: "Llegada deseada",
  __d_part_souhait_: "Salida deseada",
  __dur_e: "Duración",
  nuit_s_: "Noche(s)",
  __voyageurs: "Viajeros",
  je_suis_ouvert_e____une_n_gociation_si_besoin_:
    "Estoy abierto a la negociación si es necesario.",
  indiquez_un_nombre_de_nuits_valide_pour_la_proposi:
    "Indique un número válido de noches para la propuesta.",
  proposition_d__change_flexible__sans_dates_fix_es_:
    "Propuesta de intercambio flexible sin fechas fijas",
  __je_propose: "Yo propongo",
  __je_demande: "Pregunto",
  on_valide_les_dates_ensemble_ensuite_selon_nos_dis:
    "Luego validamos las fechas juntos según nuestra disponibilidad.",
  indiquez_un_nombre_de_nuits_valide_: "Introduzca un número válido de noches",
  proposition_d__change__n_importe_quand_dans_l_ann_:
    "Propuesta de canje en cualquier momento del año.",
  __dur_e_souhait_e: "Duración deseada",
  __p_riode_pr_f_r_e: "Periodo preferido",
  je_suis_flexible_sur_les_dates_exactes_et_pr_t_e__:
    "Soy flexible en fechas exactas y estoy dispuesto a hablar de ello.",
  proposition_invalide_: "Propuesta no válida",
  proposition_envoy_e__ouverture_de_la_discussion___:
    "Propuesta enviada, discusión abierta...",
  impossible_d_envoyer_votre_proposition____errormes:
    "No se puede enviar su propuesta",
  impossible_d_envoyer_votre_proposition_pour_le_mom:
    "No se puede enviar su propuesta en este momento",
  logement_introuvable: "Alojamiento no encontrado",
  retour_aux_logements: "Regreso al alojamiento",
  annonce_airbnb: "Anuncio de Airbnb",
  lien_airbnb_verification_helper:
    "Este enlace nos permite verificar que usted es el administrador del anuncio.",
  aucune_photo_disponible: "No hay fotos disponibles",
  logement_propos__par: "Alojamiento ofrecido por",
  __propos_de_ce_logement: "Acerca de este alojamiento",
  aucune_description_fournie_: "No se proporciona descripción",
  ce_que_propose_ce_logement: "Qué ofrece este alojamiento",
  description_du_logement: "Descripción del alojamiento",
  aucun__quipement_sp_cifi__: "Ningún equipo especificado",
  _change_entre_h_tes: "Intercambio entre anfitriones",
  votre_proposition_d__change: "Tu propuesta de intercambio",
  quand_vous_voulez: "Cuando quieras",
  je_propose: "Yo propongo",
  nuits_chez_moi: "Noches en mi casa",
  je_demande: "Pregunto",
  nuits_chez_vous: "Noches en tu casa",
  nombre_de_nuits: "Número de noches",
  p_riode_pr_f_r_e: "Periodo preferido",
  message__optionnel_: "Mensaje opcional",
  ex__nous_sommes_flexibles__on_peut_s_adapter___vos:
    "Ex somos flexibles podemos adaptarnos a tus",
  entrer_en_n_gociation: "Entrar en negociación",
  envoyer_ma_proposition: "Enviar mi propuesta",
  vous_pouvez_proposer_un__change_avec_ou_sans_dates:
    "Puedes ofrecer un intercambio con o sin fechas",
  informations_l_gales: "Información legal",
  conditions_d____utilisation: "Condiciones de uso",
  en_utilisant_traveltrok__vous_acceptez_d_utilise:
    "Al utilizar traveltrok usted acepta utilizar",
  les__changes_se_font_directement_entre_membres__:
    "Los intercambios se realizan directamente entre los miembros.",
  traveltrok_peut_suspendre_un_compte_en_cas_de_co:
    "DONKEY TRAVEL puede suspender una cuenta en caso de co",
  en_rejoignant_traveltrok__vous_acceptez_ces_engagements__la_confiance_se_construit_sur_des_actes_simples__honn_tet___respect_et_parole_tenue_:
    "Al unirte a DONKEY TRAVEL, aceptas estos compromisos. La confianza se basa en acciones simples.",
  cette_charte_est_align_e_avec_les_standards_publics_des_plateformes_majeures__respect_du_logement__fiabilit___anti_f_te__communication__:
    "Una carta sólida en línea con las mejores prácticas de otras empresas famosas.",
  retrait_du_club_en_cas_de_manquement_grave_ou_r_p_tition_:
    "Retiro del club por reincidencia o falta grave.",
  exclusion_d_finitive: "Exclusión permanente",
  compte_limit__le_temps_de_v_rifier_les_faits_et_prot_ger_la_communaut__:
    "Cuenta restringida en espera de hechos.",
  suspension_temporaire: "Suspensión temporal",
  rappel__crit_des_r_gles__avec_demande_de_correction_imm_diate_:
    "Recordatorio de las normas y corrección requerida.",
  avertissement_officiel: "Advertencia oficial",
  le_club_prot_ge_les_h_tes_fiables__les_manquements_r_p_t_s_ou_graves_entra_nent_des_mesures_imm_diates_:
    "El club protege a los huéspedes fiables. Las infracciones graves dan lugar a acciones.",
  toute_annulation_doit__tre_document_e_dans_la_messagerie_et_trait_e_par_le_support_:
    "Cualquier cancelación debe documentarse en mensajes y ser procesada por soporte.",
  on_n_annule_pas_un__change_sans_raison_valable__en_cas_de_force_majeure__sinistre__maladie_grave__impossibilit__l_gale___un_report_doit__tre_propos__au_plus_vite_:
    "No cancelamos un cambio sin una razón válida. En caso de fuerza mayor (desastre, enfermedad grave, imposibilidad legal), se deberá proponer un aplazamiento lo antes posible.",
  je_communique_vite_en_cas_de_doute_ou_de_changement_:
    "Me comunico rápidamente en caso de duda o cambio.",
  j_accueille_quelqu_un_qui_exerce_le_m_me_m_tier_d_h_te_:
    "Doy la bienvenida a alguien que haga el mismo trabajo como anfitrión.",
  j_assure_un_accueil_chaleureux_et_professionnel_:
    "Brindo una bienvenida cálida y profesional.",
  relation_entre_h_tes: "Relación entre anfitriones",
  les__ventuels_frais_de_m_nage_sont_annonc_s_et_valid_s_avant_s_jour_:
    "Cualquier tarifa de limpieza se anuncia y valida antes del cambio.",
  les_informations_d_acc_s_et_de_fonctionnement_sont_claires_:
    "La información de acceso y funcionamiento es clara.",
  linge_et_pr_paration: "Lavado y preparación",
  le_niveau_de_prestation_reste_identique__m_me_en__change_gratuit_:
    "El nivel de servicio sigue siendo el mismo, incluso en un intercambio gratuito.",
  le_logement_est_propre_et_pr_t___vivre_d_s_l_arriv_e_:
    "El alojamiento está limpio y listo para vivir a su llegada.",
  je_pr_pare_le_logement_comme_pour_un_client_airbnb_:
    "Preparo el alojamiento como para un cliente de Airbnb.",
  qualit__d_accueil__quivalente: "Calidad de recepción equivalente",
  je_respecte_le_calme__les_voisins_et_le_quartier_:
    "Respeto la tranquilidad, los vecinos y el barrio.",
  aucune_f_te___v_nement_ou_invitation_non_autoris_e_dans_le_logement_:
    "No se permiten fiestas, eventos ni invitaciones no autorizadas en el alojamiento.",
  je_respecte_le_r_glement_int_rieur_de_l_h_te_:
    "Respeto las normas internas del anfitrión.",
  vie_de_quartier_et_r_gles: "Vida y reglas del vecindario.",
  quand_des_dates_sont_bloqu_es__je_m_engage___venir_:
    "Cuando las fechas están bloqueadas, me comprometo a venir.",
  je_ne_mens_pas_sur_la_valeur_prix_habituel_de_mon_logement_:
    "No miento sobre el valor del precio habitual de mi alojamiento.",
  je_ne_mens_pas_sur_ma_fiche__mon_historique_ni_mon_logement_:
    "No miento sobre mi perfil, mi historia o mi alojamiento.",
  honn_tet__et_fiabilit_: "Honestidad y confiabilidad",
  je_respecte_le_mat_riel__les__quipements_et_les_consignes_de_d_part_:
    "Respeto los materiales, equipos e instrucciones de salida.",
  je_range_le_linge_utilis___ex__draps_en_boule___l_endroit_indiqu___pour_limiter_les_frais_de_m_nage_:
    "Guardo la ropa usada (por ejemplo, las sábanas en una bola) en el lugar indicado, para limitar los costes de limpieza.",
  je_rends_le_logement_aussi_propre_que_je_l_ai_trouv_:
    "Dejo el alojamiento tan limpio como lo encontré.",
  respect_total_du_logement: "Respeto total por la vivienda.",
  traveltrok_est_un_club_d_h_tes_s_rieux__une_bonne_note_implique_une_conduite_exemplaire__en_tant_que_voyageur_comme_en_tant_qu_h_te_:
    "DONKEY TRAVEL es un club anfitrión serio; una buena calificación implica una conducta ejemplar, tanto como viajero como anfitrión.",
  "howItWorks.cta.explore": "Explorar destinos",
  "howItWorks.cta.signup": "Ver nuestras ofertas",
  "howItWorks.cta.subtitle":
    "Empiece por alquilar su propio lugar. Luego active intercambio si desea intercambiar entre hosts.",
  "howItWorks.cta.title": "¿Listo para lanzar tus alquileres?",
  publiez_votre_logement__validez_votre_profil_et_commencez_a_recevoir_des_propositions_d_echange_:
    "Publica tu alojamiento, valida tu perfil y empieza a recibir ofertas de intercambio.",
  visualisez_la_densite_des_logements_deja_inscrits_dans_le_club__les_points_restent_anonymes__pas_d_adresse__pas_de_detail__juste_la_dynamique_du_reseau_:
    "Consulta la densidad de viviendas ya registradas en el club. Los puntos permanecen anónimos (sin dirección, sin detalles, sólo dinámica de red).",
  prenez_du_recul_pour__viter_l__puisement_li___l_accueil_continu_:
    "Da un paso atrás para evitar el agotamiento por el alojamiento continuo.",
  _an: "/ Año",
  traveltrok_connecte_les_h_tes_du_monde_entier_pour_des_s_jours_authentiques_et_abordables_:
    "DONKEY TRAVEL conecta a huéspedes de todo el mundo para estancias auténticas y asequibles.",
  ____100__made_in_france__picardie_: "🇫🇷 100% Hecho en Francia (Picardía)",
  pas_la_silicon_valley__mais_la_vall_e_de_la_haute_somme_:
    "No Silicon Valley, sino el valle del Alto Somme.",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_not_s_4_5___offre_lancement_2026___50__:
    "Intercambios en toda Europa entre anfitriones de Airbnb con una puntuación de 4,5+. Oferta de lanzamiento 2026: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes_creuses_en_vraies_respirations_sans_exploser_votre_budget_:
    "Después de meses de alojamiento, transforme sus períodos lentos en un verdadero respiro sin gastar su presupuesto.",
  prenez_du_recul_pour__viter_l__puisement_li____l_accueil_continu_:
    "Da un paso atrás para evitar el agotamiento por el alojamiento continuo.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exigences_du_terrain__puis_partagez_vos_m_thodes_et_vos_retours_d_exp_rience_:
    "Dé la bienvenida a los invitados que ya conocen los requisitos del campo y luego comparta sus métodos y comentarios.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_membres_du_club_:
    "Viaja a coste reducido gracias a los intercambios entre los miembros del club.",
  quand_votre_quota_local_est_atteint__vous_pouvez__changer_hors_plateforme_sous_r_serve_de_conformit__locale_:
    "Cuando alcance su cuota local, podrá realizar transacciones fuera de la plataforma sujeto al cumplimiento local.",
  traveltrok_est_une_r_volution_europ_enne__une_plateforme_d__changes_pour_les_h_tes_qui_paient_d_j__chauffage__taxes__imp_ts___lectricit___internet_et_entretien__et_accueillent_toute_l_ann_e_comme___l_h_tel__ici__vous__changez_avec_des_h_tes_qui_savent_accueillir__vous_partagez_vos_exp_riences__puis_vous_partez_d_couvrir_un_autre_endroit_sans_vous_ruiner_:
    "DONKEY TRAVEL es una revolución europea: una plataforma de intercambio para huéspedes que ya pagan calefacción, impuestos, electricidad, internet y mantenimiento, y son bienvenidos durante todo el año como en un hotel. Aquí interactúas con anfitriones que saben cómo recibirte, compartes tus experiencias y luego vas y descubres otro lugar sin gastar mucho dinero.",
  ___notre_mod_le_repose_uniquement_sur_les_abonnements__pas_sur_l_exploitation_des_donn_es_:
    "👉 Nuestro modelo se basa únicamente en suscripciones, no en la explotación de datos.",
  ___sans_publicit___sans_revente_de_donn_es__100___financ__par_les_membres_:
    "🔒 Sin publicidad. Sin reventa de datos. 100% financiado por miembros.",
  le_club_n_est_pas_un_conseil_juridique___chaque_membre_doit_respecter_les_r_gles_locales__d_clarations__quotas__copropri_t___fiscalit___etc___:
    "El club no es asesoramiento jurídico; cada miembro debe respetar las normas locales (declaraciones, cuotas, copropiedad, impuestos, etc.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_h_tes_airbnb:
    "Una plataforma de intercambio europea reservada a los anfitriones de Airbnb",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_unique_pour__changer_dans_toute_l_europe_:
    "Club privado para huéspedes con calificación 4.5+: una suscripción única para intercambiar en toda Europa.",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_ou__gale___4_5_:
    "Reservado para anfitriones de Airbnb con una calificación superior o igual a 4,5.",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eur_an__prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "Reducción del 50% en 2026: 25 EUR/año en lugar de 50 EUR/año. Precio garantizado de por vida para las 1000 primeras inscripciones.",
  basse_saison__pause__rencontres_entre_h_tes___conomies_vacances__tout_est_pens__pour_les_h_tes_actifs_en_europe_:
    "Temporada baja, escapadas, reuniones entre huéspedes, ahorro en vacaciones: todo está pensado para los huéspedes activos en Europa.",
  accueillez_des_membres_et_faites_vous_accueillir_en_retour__un__change_simple__direct_et_sans_argent_entre_propri_taires_:
    "Bienvenidos miembros y sean bienvenidos nuevamente. Un intercambio sencillo, directo y sin efectivo entre propietarios.",
  _nous_avons__chang__notre_maison___lyon_contre_une_villa_en_corse__co_t___0___:
    "'\"Cambiamos nuestra casa en Lyon por una villa en Córcega. Coste: 0 €.\"'",
  pas_de_monnaie__pas_de_points__juste_un_accord_entre_deux_propri_taires__je_viens_chez_toi__tu_viens_chez_moi_:
    "Sin monedas, sin puntos. Sólo un acuerdo entre dos propietarios. Yo vengo a tu casa, tú vienes a mi casa.",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous_mettez_d_accord_pour__changer_vos_logements_:
    "Encuentras un miembro que te gusta y aceptas intercambiar alojamiento.",
  pas_de_points___compter__juste_le_plaisir_de_partager_et_de_se_rencontrer_:
    "No hay puntos para contar. Simplemente el placer de compartir y conocer.",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_voyager_:
    "Más que una economía, es una nueva forma de viajar.",
  les__changes_sont_totalement_gratuits__pas_de_frais_de_service__pas_de_frais_de_m_nage__sauf_accord_sp_cifique__:
    "Los intercambios son completamente gratuitos. Sin gastos de servicio ni de limpieza (a menos que se acuerde específicamente).",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_accueillez_quelqu_un_qui_conna_t_la_valeur_d_un_logement_:
    "Sólo los hosts verificados pueden comerciar. Estás dando la bienvenida a alguien que conoce el valor de una casa.",
  oubliez_la_valeur_des_points__une_nuit_est_une_nuit__l__change_est_bas__sur_la_confiance_entre_h_tes_:
    "Olvídate del valor de los puntos. Una noche es una noche. El intercambio se basa en la confianza entre anfitriones.",
  __an: "/ Año",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_no:
    "Intercambios en toda Europa entre anfitriones de Airbnb con una puntuación de 4,5+. Oferta de lanzamiento 2026: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes:
    "Después de meses de alojamiento, transforme sus períodos lentos en un verdadero respiro sin gastar su presupuesto.",
  prenez_du_recul_pour__viter_l__puisement_li____l_a:
    "Da un paso atrás para evitar el agotamiento por el alojamiento continuo.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exig:
    "Dé la bienvenida a los invitados que ya conocen los requisitos del campo y luego comparta sus métodos y comentarios.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_mem:
    "Viaja a coste reducido gracias a los intercambios entre los miembros del club.",
  quand_votre_quota_local_est_atteint__vous_pouvez__:
    "Cuando alcance su cuota local, podrá realizar transacciones fuera de la plataforma sujeto al cumplimiento local.",
  la_r_volution_des_h_tes_en_europe: "La revolución anfitriona en Europa",
  enfin_une_pause_pour_les_h_tes_airbnb_not_s_4_5_:
    "Finalmente un descanso para los anfitriones de Airbnb con calificación 4.5+",
  traveltrok_est_une_r_volution_europ_enne__une_plat:
    "DONKEY TRAVEL es una revolución europea: una plataforma de intercambio para huéspedes que ya pagan calefacción, impuestos, electricidad, internet y mantenimiento, y son bienvenidos durante todo el año como en un hotel. Aquí interactúas con anfitriones que saben cómo recibirte, compartes tus experiencias y luego vas y descubres otro lugar sin gastar mucho dinero.",
  prix_garanti___vie_pour_les_1000_premiers_inscrits:
    "Precio garantizado de por vida para las 1000 primeras inscripciones.",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produi:
    "En DONKEY TRAVEL tus datos no son un producto.",
  nous_ne_vendons_jamais_les_informations_de_nos_mem:
    "Nunca vendemos la información de nuestros miembros.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___:
    "No compartimos ningún dato con terceros con fines comerciales.",
  le_site_est_s_curis__et_vos__changes_restent_priv_:
    "El sitio es seguro y sus intercambios permanecen privados.",
  traveltrok_est_garanti_sans_publicit____vous__tes_:
    "DONKEY TRAVEL tiene la garantía de estar libre de publicidad: usted es el miembro, no el producto.",
  ___notre_mod_le_repose_uniquement_sur_les_abonneme:
    "👉 Nuestro modelo se basa únicamente en suscripciones, no en la explotación de datos.",
  ___sans_publicit___sans_revente_de_donn_es__100___:
    "🔒 Sin publicidad. Sin reventa de datos. 100% financiado por miembros.",
  le_club_n_est_pas_un_conseil_juridique___chaque_me:
    "El club no es asesoramiento jurídico; cada miembro debe respetar las normas locales (declaraciones, cuotas, copropiedad, impuestos, etc.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_:
    "Una plataforma de intercambio europea reservada a los anfitriones de Airbnb",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u:
    "Club privado para huéspedes con calificación 4.5+: una suscripción única para intercambiar en toda Europa.",
  acc_s_r_serv_: "Acceso reservado",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_:
    "Reservado para anfitriones de Airbnb con una calificación superior o igual a 4,5.",
  europe_unique: "Europa única",
  "50eur_an_pour__changer_dans_toute_l_europe_":
    "50EUR/año para cambiar en toda Europa.",
  lancement_2026: "Lanzamiento 2026",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu:
    "Reducción del 50% en 2026: 25 EUR/año en lugar de 50 EUR/año. Precio garantizado de por vida para las 1000 primeras inscripciones.",
  club_d__change_h_tes_airbnb: "Club de intercambio de anfitriones de Airbnb",
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes:
    "Optimice sus periodos valle gracias a los intercambios",
  basse_saison__pause__rencontres_entre_h_tes___cono:
    "Temporada baja, escapadas, reuniones entre huéspedes, ahorro en vacaciones: todo está pensado para los huéspedes activos en Europa.",
  r_serv__aux_h_tes_traveltrok: "Reservado para huéspedes de DONKEY TRAVEL",
  voyagez_gratuitement_gr_ce___votre_logement:
    "Viaja gratis con tu alojamiento",
  accueillez_des_membres_et_faites_vous_accueillir_e:
    "Bienvenidos miembros y sean bienvenidos nuevamente. Un intercambio sencillo, directo y sin efectivo entre propietarios.",
  devenir_h_te: "Conviértete en anfitrión",
  comment__a_marche__: "¿Cómo funciona?",
  _nous_avons__chang__notre_maison___lyon_contre_une:
    "'\"Cambiamos nuestra casa en Lyon por una villa en Córcega. Coste: 0 €.\"'",
  amis_partageant_un_repas_en_corse:
    "Amigos compartiendo una comida en Córcega",
  sophie___marc__membres_depuis_2023: "Sophie & Marc, miembros desde 2023",
  pas_besoin_d__changer_aux_m_mes_dates____tu_viens:
    "No es necesario intercambiar en las mismas fechas: ¡tú vienes a mi casa en junio, yo vengo a tu casa en septiembre!",
  l__change_direct___simple_et_humain: "Intercambio directo: sencillo y humano",
  pas_de_monnaie__pas_de_points__juste_un_accord_ent:
    "Sin monedas, sin puntos. Sólo un acuerdo entre dos propietarios. Yo vengo a tu casa, tú vienes a mi casa.",
  "1__accord_mutuel": "1. Acuerdo mutuo",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous:
    "Encuentras un miembro que te gusta y aceptas intercambiar alojamiento.",
  "2__flexibilit__totale": "2. Flexibilidad total",
  "3__z_ro_comptabilit_": "3. Contabilidad cero",
  pas_de_points___compter__juste_le_plaisir_de_parta:
    "No hay puntos para contar. Simplemente el placer de compartir y conocer.",
  pourquoi_les_h_tes_adorent_ce_syst_me__:
    "¿Por qué a los anfitriones les encanta este sistema?",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_:
    "Más que una economía, es una nueva forma de viajar.",
  "0__de_frais": "0€ honorarios",
  les__changes_sont_totalement_gratuits__pas_de_frai:
    "Los intercambios son completamente gratuitos. Sin gastos de servicio ni de limpieza (a menos que se acuerde específicamente).",
  confiance_totale: "Confianza total",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac:
    "Sólo los hosts verificados pueden comerciar. Estás dando la bienvenida a alguien que conoce el valor de una casa.",
  simplicit_: "Sencillez",
  oubliez_la_valeur_des_points__une_nuit_est_une_nui:
    "Olvídate del valor de los puntos. Una noche es una noche. El intercambio se basa en la confianza entre anfitriones.",
  rejoignez_la_communaut__des_h_tes: "ÚNase a la comunidad anfitriona",
  rejoignez_la_communaut__et_commencez____changer_:
    "Únase a la comunidad y comience a chatear.",
  commencer_maintenant: "Empezar ahora",
  chargement___: "Cargando...",
  accueil: "Bienvenido",
  comment_a_marche: "Cómo funciona",
  vos_engagements: "Tus compromisos",
  pays: "País",
  logements: "Alojamiento",
  _change_h_te: "Intercambio de host",
  devenir_membre: "Hazte miembro",
  se_d_connecter: "Finalizar la sesión",
  mon_espace: "Mi espacio",
  connexion: "Conexión",
  connect_: "Conectado",
  visuel_en_cours_de_g_n_ration_ai___: "Visual generado por IA...",
  tableau_de_bord: "Panel",
  mes_annonces: "Mis anuncios",
  o__je_veux_aller: "Donde quiero ir",
  qui_veut_venir_chez_moi: "Emparejamiento inteligente",
  destinations: "Destinos",
  carte_des_membres: "Tarjeta de socio",
  calendrier: "Calendario",
  votre_coffre: "Tu seguro",
  favoris: "Favoritos",
  messages: "Mensajes",
  mon_profil: "Mi perfil",
  pr_f_rences: "Preferencias",
  profil: "Perfil",
  h_te: "Anfitrión",
  membre_fondateur: "Miembro fundador",
  membre: "Miembro",
  r_duire__tendre: "Reducir/ampliar",
  r_duire_le_menu: "Contraer menú",
  cette_page_n_a_pas__t__g_n_r_e: "Esta página no fue generada",
  donne_moi_plus_de_d_tails_sur_cette_page_pour_que_je_puisse_la_g_n_rer:
    "Dame más detalles sobre esta página para poder generarla.",
  connexion_en_cours___: "Conexión en progreso...",
  email_ou_mot_de_passe_incorrect:
    "Correo electrónico o contraseña incorrectos",
  une_erreur_est_survenue: "Ha ocurrido un error",
  erreur_de_connexion_google: "Error de conexión de Google",
  connecte_toi_pour_retrouver_ta_communaut_:
    "Inicia sesión para encontrar tu comunidad",
  rejoins_la_communaut__des_h_tes_traveltrok:
    "Únete a la comunidad de anfitriones de DONKEY TRAVEL",
  inscription: "Registro",
  continuer_avec_google: "Continuar con Google",
  ou: "O",
  ton_pr_nom_et_nom: "Tu nombre y apellido",
  jean_h_mar: "Jean Hemar",
  lien_annonce_airbnb: "Enlace a tu anuncio de Airbnb",
  veuillez_saisir_un_lien_airbnb_valide:
    "Proporcione un enlace de Airbnb válido",
  lien_calendrier_ical:
    "Enlace de iCal a tu calendario de Airbnb (opcional por ahora)",
  lien_ical_explication_lecture_seule:
    "Donkey Travel nunca cambia tu calendario de Airbnb. Solo lo leemos para mostrar tu disponibilidad. Tendrás que seguir bloqueando manualmente tus fechas de canje en Airbnb para evitar reservas dobles.",
  note_airbnb: "Calificación de Airbnb",
  abonnement: "Suscripción",
  europe_unique___50eur_an: "Europa única - 50 EUR/año",
  offre_lancement_2026__25eur_an___50__:
    "Oferta de lanzamiento 2026: 25EUR/año (-50%)",
  prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "Precio garantizado de por vida para las 1000 primeras inscripciones.",
  mot_de_passe: "Contraseña",
  "8_caract_res_minimum": "8 caracteres mínimo",
  connexion___: "Conexión...",
  cr_ation_du_compte___: "Creando la cuenta...",
  se_connecter: "Acceso",
  cr_er_mon_compte: "Crear mi cuenta",
  mot_de_passe_oubli___: "¿Olvidaste tu contraseña?",
  en_cr_ant_un_compte__tu_acceptes_nos_: "Al crear una cuenta, aceptas nuestra",
  cgu: "UGE",
  _et_notre_: "Y nuestro",
  politique_de_confidentialit_: "Política de privacidad",
  r_servation_de_logements: "Reserva de alojamiento",
  support_h_te_prioritaire: "Soporte prioritario para anfitriones",
  carte___filtres_avanc_s: "Mapa + filtros avanzados",
  flux_de_r_servation__tape_par__tape: "Flujo de reserva paso a paso",
  couverture_dommages_assistance: "Cobertura de daños/asistencia",
  multi_logements___reporting: "Vivienda múltiple + informes",
  comparatif_des_modes: "Comparación de modos",
  ce_que_tu_actives_selon_ton_usage_traveltrok_:
    "Lo que activas según tu uso de TRAVELTROK.",
  fonction: "Función",
  voyageur: "Viajero",
  pro: "Pro",
  abonnement_europe_unique: "Suscripción única europea",
  rejoindre_le_club_europe: "ÚNase al club de Europa",
  basse_saison: "Temporada baja",
  pause: "Hacer una pausa",
  rencontres: "Conoce a los anfitriones",
  _conomies: "Ahorros",
  quota_atteint: "Cuota alcanzada",
  _ligibilit_: "Elegibilidad",
  zone_d__change: "ÁRea de intercambio",
  toute_l_europe: "Toda Europa",
  mod_le: "Modelo",
  abonnement_unique_annuel: "Suscripción única anual",
  propri_taire_europ_en_en_pause: "Propietario europeo en vacaciones",
  v_rification: "Verificación",
  h_tes_certifi_s: "Anfitriones certificados",
  abonnement_unique_traveltrok: "Suscripción única VIAJE EN BURRO",
  offre_lancement_2026__25eur_an_au_lieu_de_50eur_an:
    "Oferta de lanzamiento 2026: 25EUR/año en lugar de 50EUR/año",
  pourquoi_ce_club_fonctionne_pour_les_h_tes:
    "Por qué este club funciona para anfitriones",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produit_:
    "En DONKEY TRAVEL tus datos no son un producto.",
  nous_ne_vendons_jamais_les_informations_de_nos_membres_:
    "Nunca vendemos la información de nuestros miembros.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___des_fins_commerciales_:
    "No compartimos ningún dato con terceros con fines comerciales.",
  le_site_est_s_curis__et_vos__changes_restent_priv_s_:
    "El sitio es seguro y sus intercambios permanecen privados.",
  traveltrok_est_garanti_sans_publicit____vous__tes_le_membre__pas_le_produit_:
    "DONKEY TRAVEL tiene la garantía de estar libre de publicidad: usted es el miembro, no el producto.",
  rejoindre_le_club: "ÚNete al club",
  trouver_un_h_te: "Encontrar un anfitrión",
  proposer_un__change: "Sugerir un intercambio",
  synchronisation_mise___jour_avec_succ_s:
    "Sincronización actualizada exitosamente",
  erreur_lors_de_la_mise___jour: "Error durante la actualización",
  indisponible: "Indisponible",
  r_serv_: "Reservar",
  erreur_chargement: "Error de carga",
  inconnue: "Desconocido",
  impossible_de_r_cup_rer_le_calendrier_ical__v_rifiez_l_url_ical_airbnb_et_r_essayez_:
    "No se puede recuperar el calendario de iCal. Verifique la URL de iCal Airbnb y vuelva a intentarlo.",
  r_servation: "Reserva",
  _v_nements_synchronis_s: "Eventos sincronizados",
  _v_nements_import_s: "Eventos importados",
  erreur_sync: "Error de sincronización",
  _chec_de_synchronisation: "Fallo de sincronización",
  dates_bloqu_es_avec_succ_s: "Fechas bloqueadas exitosamente",
  erreur_blocage: "Error de bloqueo",
  mois: "Mes",
  aujourd_hui: "Hoy",
  d_tails: "Detalles",
  actions: "Comportamiento",
  bloquer: "Para bloquear",
  filtres: "Filtros",
  confirm_: "Confirmado",
  en_attente: "En espera",
  proposition: "Propuesta",
  bloqu_: "Obstruido",
  synchronisation: "Sincronización",
  configurer: "Configurar",
  airbnb_connect_: "Airbnb conectado",
  derni_re_synchro_r_ussie: "ÚLtima sincronización exitosa",
  derni_re_synchro_en__chec: "ÚLtima sincronización fallida",
  calendrier_connect___lancez_une_synchro_pour_importer_vos_r_servations_airbnb_:
    "Calendario conectado. Inicie una sincronización para importar sus reservas de Airbnb.",
  synchro___: "Sincronizar...",
  forcer_la_synchro: "Forzar sincronización",
  non_synchronis_: "No sincronizado",
  connectez_votre_calendrier_airbnb_pour__viter_les_doubles_r_servations__:
    "¡Conecta tu calendario de Airbnb para evitar reservas dobles!",
  bloquer_des_dates: "Bloquear fechas",
  s_lection: "Selección",
  jours: "Días",
  raison__optionnel__ex__travaux_: "Motivo (opcional, por ejemplo: Obras)",
  annuler: "Cancelar",
  confirmer: "Confirmar",
  synchronisation_airbnb: "Sincronización de Airbnb",
  ajoutez_vos_liens_airbnb_pour_synchroniser_automatiquement_vos_r_servations_et__viter_les_doublons_:
    "Añade tus enlaces de Airbnb para sincronizar automáticamente tus reservas y evitar duplicados.",
  lien_de_l_annonce_airbnb: "Enlace de anuncio de Airbnb",
  airbnb_ical_calendar_link: "Enlace al calendario iCal de Airbnb",
  disponible_dans_param_tres_de_l_annonce_export_du_calendrier:
    "Disponible en Configuración de anuncios Exportación de calendario",
  enregistrer: "Ahorrar",
  veuillez_cliquer_sur__localiser__pour_valider_l_adresse_avant_de_continuer_:
    "Haga clic en 'Localizar' para validar la dirección antes de continuar.",
  vous_devez__tre_connect__pour_publier_: "Debes iniciar sesión para publicar.",
  id_manquant_apr_s_sauvegarde: "Falta ID después de la copia de seguridad",
  erreur_upload_photo: "Error al subir la foto",
  erreur_sauvegarde_metadata_photos: "Error al guardar fotos con metadatos",
  une_erreur_est_survenue_lors_de_la_sauvegarde: "Ocurrió un error al guardar",
  quitter: "Dejar",
  modification: "Editar",
  cr_ation: "Creación",
  _tape: "Escenario",
  sur: "Seguro",
  sauvegarde_en_cours___: "Copia de seguridad en progreso...",
  retour: "Atrás",
  sauvegarde___: "Respaldo...",
  mettre___jour: "Para actualizar",
  publier_l_annonce: "Publicar el anuncio",
  suivant: "Siguiente",
  _tes_vous_s_r_de_vouloir_supprimer_cette_annonce__:
    "¿Estás seguro de que deseas eliminar este anuncio?",
  impossible_de_supprimer_l_annonce__: "No se puede eliminar el anuncio:",
  g_rez_vos_logements_et_leur_disponibilit__:
    "Gestiona tus alojamientos y su disponibilidad.",
  ajouter_une_annonce: "Añadir un anuncio",
  vous_n_avez_aucune_annonce: "No tienes anuncios",
  commencez___gagner_un_revenu_en_louant_votre_logement__c_est_simple_et_rapide_:
    "Empiece a obtener ingresos alquilando su casa. Es rápido y fácil.",
  cr_er_ma_premi_re_annonce: "Crear mi primer anuncio",
  publi_: "Publicado",
  brouillon: "Borrador",
  __nuit: "/ Noche",
  voir_l_annonce: "Ver el anuncio",
  modifier: "Para modificar",
  supprimer: "BORRAR",
  quels__quipements_proposez_vous__: "¿Qué equipo ofrece?",
  s_lectionnez_tout_ce_qui_est_disponible_pour_les_voyageurs_:
    "Seleccione todo lo que está disponible para los viajeros.",
  aucun_sch_ma_conversation_compatible_trouv_:
    "No se encontró ningún diagrama de conversación compatible.",
  logements_concern_s: "Vivienda en cuestión",
  logement_non_pr_cis_: "Alojamiento no especificado",
  erreur_lors_de_l_envoi_du_message_: "Error al enviar el mensaje.",
  rechercher_une_conversation: "Buscar una conversación",
  demandes_re_ues: "Solicitudes recibidas",
  mes_demandes: "Mis peticiones",
  aucune_demande_re_ue_: "No se recibieron solicitudes.",
  aucune_demande_envoy_e_: "No se envió ninguna solicitud.",
  photo_de_profil: "Foto de perfil",
  localisation_non_pr_cis_e: "Ubicación no especificada",
  listing_: "Listado:",
  en_ligne: "En línea",
  vous: "TÚ",
  _crivez_votre_message___: "Escribe tu mensaje...",
  s_lectionnez_une_conversation: "Seleccione una conversación",
  pour_commencer___changer: "Para empezar a operar",
  logement_propos_: "Alojamiento propuesto",
  description_non_pr_cis_e: "Descripción no especificada",
  ch_: "Cap.",
  voy_: "Ver.",
  nuit: "Noche",
  prix_non_pr_cis_: "Precio no especificado",
  voir: "Ver",
  aucune_annonce_li_e___cette_conversation_:
    "No hay anuncios relacionados con esta conversación.",
  s_lectionnez_une_conversation_pour_voir_les_d_tails_:
    "Seleccione una conversación para ver los detalles.",
  bonjour: "Buen día",
  voici_ce_qui_se_passe_sur_votre_compte_aujourd_hui_:
    "Esto es lo que está sucediendo en su cuenta hoy.",
  annonces_en_ligne: "Anuncios en línea",
  nouveaux_messages: "Nuevas publicaciones",
  prochains__changes: "Próximos intercambios",
  matching_section__o__je_veux_aller:
    "Sección correspondiente: Adónde quiero ir",
  ajoutez_jusqu__10_villes_avec_rayon_en_km_et_vos_dates_de_d_part_pour_recevoir_des_propositions_mieux_cibl_es_:
    "Agregue hasta 10 ciudades con un radio en km y sus fechas de salida para recibir propuestas más específicas.",
  configurer_mes_pr_f_rences: "Configurar mis preferencias",
  pr_t___recevoir_vos_premiers_voyageurs__:
    "¿Listo para recibir a tus primeros viajeros?",
  compl_tez_votre_profil_et_publiez_votre_premi_re_annonce_pour_commencer_____changer_votre_logement_avec_la_communaut__traveltrok_:
    "Complete su perfil y publique su primer anuncio para comenzar a intercambiar su alojamiento con la comunidad TravelIntercambio.",
  cr_er_mon_annonce: "Crear mi anuncio",
  compl_ter_mon_profil: "Completa mi perfil",
  impossible_de_charger_vos_preferences_:
    "No se pueden cargar tus preferencias.",
  preferences_enregistrees_: "Preferencias guardadas.",
  impossible_d_enregistrer_vos_preferences_:
    "No se pueden guardar sus preferencias.",
  impossible_de_supprimer_votre_profil_: "No se puede eliminar tu perfil.",
  chargement_des_preferences___: "Cargando preferencias...",
  unites_de_distance: "Unidades de distancia",
  kilom_tres__km_: "Kilómetros (km)",
  format_europeen_par_defaut: "Formato europeo predeterminado",
  miles__mi_: "Millas (mi)",
  format_anglo_saxon: "Formato anglosajón",
  visibilite_du_profil: "Visibilidad del perfil",
  mettre_mon_profil_en_pause: "Pausar mi perfil",
  me_masquer_dans_les_resultats_de_recherche:
    "Esconderme de los resultados de búsqueda",
  zone_sensible: "Zona sensible",
  suppression___: "Supresión...",
  supprimer_mon_profil: "Eliminar mi perfil",
  pensez_a_enregistrer_vos_modifications_: "Recuerde guardar sus cambios.",
  enregistrement___: "Registro...",
  enregistrer_les_preferences: "Guardar preferencias",
  impossible_de_charger_votre_profil_: "No se puede cargar tu perfil.",
  profil_enregistr__partiellement__la_base_de_donn_es_doit__tre_mise___jour__migration_sql__:
    "Perfil parcialmente guardado. La base de datos debe estar actualizada (migración SQL).",
  profil_mis___jour_avec_succ_s_: "Perfil actualizado exitosamente.",
  profil_non_enregistr___la_base_de_donn_es_doit__tre_migr_e__colonnes_manquantes__:
    "Perfil no guardado: es necesario migrar la base de datos (faltan columnas).",
  profil_non_enregistr___trop_de_colonnes_manquantes__lancez_la_migration_sql_:
    "Perfil no guardado: faltan demasiadas columnas. Inicie la migración de SQL.",
  votre_base_de_donn_es_n_est_pas___jour__lancez_la_migration_sql_puis_r_essayez_:
    "Su base de datos no está actualizada. Ejecute la migración de SQL e inténtelo de nuevo.",
  erreur_lors_de_la_mise___jour_: "Error durante la actualización.",
  photo_de_profil_mise___jour_: "Foto de perfil actualizada.",
  erreur_upload_photo_: "Error al subir la foto.",
  photo_de_couverture_mise___jour_: "Foto de portada actualizada.",
  erreur_upload_couverture_: "Error al subir la portada.",
  document_envoy__pour_v_rification_: "Documento enviado para verificación.",
  erreur_lors_de_l_envoi_du_document_: "Error al enviar el documento.",
  impossible_de_charger_votre_profil_pour_le_moment_:
    "No se puede cargar su perfil en este momento.",
  mon_profil_h_te: "Mi perfil de anfitrión",
  identit___r_seaux_et_infos_de_matching:
    "Identidad, redes e información coincidente.",
  plus_votre_profil_est_complet__plus_le_moteur_peut_proposer_des_h_tes_compatibles_:
    "Cuanto más completo sea su perfil, más hosts compatibles podrá sugerir el motor.",
  compl_tude_du_profil: "Completitud del perfil",
  couverture: "Frazada",
  photo_principale: "Foto principal",
  h_te_traveltrok: "Anfitrión VIAJE EN BURRO",
  localisation_non_renseign_e: "Ubicación no proporcionada",
  ajoutez_une_photo_large_pour_mieux_pr_senter_votre_univers_d_h_te_:
    "Agrega una foto grande para presentar mejor tu mundo anfitrión.",
  destinations_cibl_es: "Destinos específicos",
  dates_pr_vues: "Fechas previstas",
  configurer___o__je_veux_aller__: "Configurar “Adónde quiero ir”",
  statut_identit_: "Estado de identidad",
  v_rifi_: "Verificado",
  en_cours: "En curso",
  non_v_rifi_: "No verificado",
  ajoutez_une_pi_ce_d_identit__pour_renforcer_la_confiance_de_la_communaut__:
    "Agregue una identificación para generar confianza en la comunidad.",
  envoyer_document: "Enviar documento",
  identit__et_contact: "Identidad y contacto",
  pr_nom: "Nombre de pila",
  nom: "Nombre",
  pseudo_public: "Apodo público",
  email: "Correo electrónico",
  t_l_phone: "Teléfono",
  r_seaux_et_liens: "Redes y enlaces",
  site_web: "Sitio web",
  localisation_et_mode_de_voyage: "Ubicación y modo de viaje.",
  pays_de_r_sidence: "País de residencia",
  s_lectionnez_un_pays: "Seleccione un país",
  ville_de_r_sidence: "Ciudad de residencia",
  amiens: "Amiens",
  combien_de_personnes_voyagent__: "¿Cuántas personas viajan?",
  voyagez_vous_avec_des_animaux__: "¿Viajas con animales?",
  oui: "Sí",
  non: "No",
  voyagez_vous_avec_des_b_b_s__: "¿Viajas con bebés?",
  bio_h_te: "Biografía del anfitrión",
  pr_sentez_votre_style_d_accueil_et_votre_logement_:
    "Presente su estilo de hospitalidad y su alojamiento.",
  pr_sentation_de_la_famille: "Presentación de la familia",
  qui_voyage__habitudes__rythme__type_de_s_jour_recherch___:
    "Quién viaja, hábitos, ritmo, tipo de estancia buscada...",
  compl_tez_aussi___o__je_veux_aller___pour_activer_un_matching_plus_pr_cis_:
    "Complete también “Adónde quiero ir” para activar una coincidencia más precisa.",
  enregistrer_le_profil: "Guardar perfil",
  horizon_contrat: "Horizonte del contrato",
  "24_mois_apres_le_1er_sejour": "24 meses después de la primera estancia",
  nuits_que_je_dois: "Noches que debo",
  nuits_qu_on_me_doit: "Noches que debo",
  echanges_ouverts: "Intercambios abiertos",
  echanges_proches_echeance: "Operaciones cercanas al vencimiento",
  alerte_solde_des_echanges: "Alerta de saldo de cambio",
  aucun_profil_a_risque_detecte_pour_le_moment_:
    "No se ha detectado ningún perfil de riesgo por el momento.",
  contrats_en_cours: "Contratos vigentes",
  personne: "Persona",
  logement: "Alojamiento",
  contrat: "CONTRATO",
  dates: "Fechas",
  echange_effectue: "Intercambio realizado",
  solde_nuits: "Noches de rebajas",
  temps_restant: "Tiempo restante",
  "1er_sejour_": "1ª estancia:",
  echeance_: "Fecha de vencimiento:",
  ils_sont_venus__fait: "Ellos vinieron: hecho",
  ils_sont_venus__en_attente: "Ellos vinieron: esperando",
  je_suis_alle__fait: "Fui: hecho",
  je_suis_alle__en_attente: "Fui: esperando",
  je_dois: "Tengo que",
  nuits: "Noches",
  on_me_doit: "Me deben",
  carte_des_p_rim_tres_de_recherche: "Mapa de áreas de investigación",
  villes_localis_es: "Pueblos localizados",
  mise___jour_de_la_carte___: "Actualizando el mapa...",
  vous_devez__tre_connect__pour_g_rer_vos_pr_f_rences_:
    "Debes iniciar sesión para gestionar tus preferencias.",
  impossible_de_charger_vos_pr_f_rences_de_matching_pour_le_moment_:
    "No se pueden cargar tus preferencias de coincidencia en este momento.",
  ajoutez_au_moins_une_ville_cible_pour_activer_le_matching_:
    "Agregue al menos una ciudad objetivo para activar la coincidencia.",
  une_p_riode_a_une_date_de_fin_ant_rieure___la_date_de_d_part_:
    "Un período tiene una fecha de finalización anterior a la fecha de inicio.",
  s_lectionnez_au_moins_un_pays_si_vous_activez_le_filtre_de_contact_par_pays_:
    "Selecciona al menos un país si habilitas el filtro de contactos por país.",
  pr_f_rences_enregistr_es__les_pays_cibl_s_sont_conserv_s_localement_tant_que_la_migration_sql_n_est_pas_appliqu_e_:
    "Preferencias guardadas. Los países de destino se mantienen localmente hasta que se aplique la migración de SQL.",
  pr_f_rences_de_matching_enregistr_es_avec_succ_s_:
    "Las preferencias coincidentes se guardaron correctamente.",
  pr_f_rences_non_enregistr_es__base_non_migr_e__lancez_la_migration_sql_:
    "Preferencias no guardadas: base de datos no migrada. Inicie la migración de SQL.",
  erreur_lors_de_l_enregistrement_: "Error al guardar.",
  matching_intelligent: "Emparejamiento inteligente",
  indiquez_vos_villes_cibles_et_vos_p_riodes_de_d_part__traveltrok_pourra_proposer_les_h_tes_les_plus_compatibles_:
    "Indique sus ciudades de destino y sus períodos de salida: DONKEY TRAVEL podrá ofrecerle los anfitriones más compatibles.",
  retour_au_profil: "Volver al perfil",
  villes_et_rayon_de_recherche: "Ciudades y radio de búsqueda",
  jusqu___10_villes__ex__amiens_2_km__paris_5_km__lille_20_km__:
    "Hasta 10 ciudades (por ejemplo: Amiens 2 km, París 5 km, Lille 20 km).",
  villes_actives: "Ciudades activas",
  ville: "Ciudad",
  choisir_un_pays: "Elige un país",
  saisissez_une_ville: "Introduce una ciudad",
  choisissez_le_pays_d_abord: "Elige el país primero",
  rayon: "Radio",
  supprimer_cette_ville: "Eliminar esta ciudad",
  ajouter_une_ville: "Agregar una ciudad",
  ces_villes_seront_utilis_es_pour_proposer_des_changes_cibl_s_:
    "Estas ciudades se utilizarán para ofrecer intercambios específicos.",
  enregistrer_mes_pr_f_rences: "Guardar mis preferencias",
  pays_d_europe___visiter: "Países europeos para visitar.",
  cochez_les_pays_qui_vous_int_ressent__vous_pouvez_ensuite_limiter_les_prises_de_contact___ces_pays_:
    "Consulta los países que te interesan. Luego puede limitar los contactos a estos países.",
  pays_s_lectionn_s: "Países seleccionados",
  tout_cocher: "Comprobar todo",
  tout_d_cocher: "Desmarcar todo",
  _tre_contact__uniquement_par_les_membres_de_ces_pays:
    "Ser contactado sólo por miembros de estos países.",
  ce_filtre_sera_utilis__dans_votre_matching_automatique_:
    "Este filtro se utilizará en su coincidencia automática.",
  union_europ_enne: "Unión Europea",
  hors_union_europ_enne: "Fuera de la Unión Europea",
  agenda_des_d_parts_souhait_s: "Horario de salidas deseadas",
  ajoutez_les_p_riodes_o__vous_souhaitez_partir_pour_lancer_un_matching_sur_des_cr_neaux_communs_:
    "Agrega los períodos en los que deseas salir para comenzar a emparejar en espacios comunes.",
  p_riode_s__active_s_: "Período(s) activo(s)",
  aucune_p_riode_ajout_e_pour_le_moment_: "Aún no se han agregado períodos.",
  p_riode: "Período",
  supprimer_cette_p_riode: "Eliminar este período",
  d_part: "Partida",
  commentaire__optionnel_: "Comentario (opcional)",
  ajouter_une_p_riode: "Agregar un punto",
  r_sum__matching: "Coincidencia resumida",
  villes_cibles: "Ciudades objetivo",
  rayon_moyen: "Radio promedio",
  p_riodes_planifi_es: "Períodos planificados",
  pays_cibl_s: "Países objetivo",
  contacts_limit_s_aux_pays_coch_s: "Contactos limitados a los países marcados",
  contacts_ouverts___tous_les_pays: "Contactos abiertos a todos los países.",
  agenda_aper_u: "Resumen de la agenda",
  ajoutez_une_p_riode_pour_afficher_votre_agenda_de_d_part_:
    "Agregue un período para mostrar su calendario de salida.",
  sans_commentaire: "Sin comentarios",
  logement_traveltrok: "VIAJES EN BURRO alojamiento",
  localisation_a_preciser: "Ubicación por especificar",
  logements_trouves: "Alojamiento encontrado",
  plus_recents: "Más reciente",
  capacite_max: "Capacidad máxima",
  h_tes: "Anfitriones",
  villes: "Ciudades",
  logements_disponibles: "Alojamiento disponible",
  pays_disponibles: "Países disponibles",
  marie_accepte__: "¡María acepta!",
  nuits_a_reims_contre: "Noches en Reims contra",
  nuits_a_paris: "Noches en paris",
  l_histoire_de_marie_jean: "La historia de María y Jean",
  "1__marie_consulte_l_agenda_de_jean": "1. Marie consulta el diario de Jean.",
  elle_voit_que_jean_a_des_dates_libres_dans_2_semaines__parfait_pour_elle___jean_confirme_qu_il_peut_liberer_ces_dates_:
    "Ve que Jean tiene citas libres en 2 semanas. ¡Perfecto para ella! Jean confirma que puede publicar estas fechas.",
  h_tes_actifs: "Anfitriones activos",
  pays_couverts: "Países cubiertos",
  echanges_realises: "Intercambios realizados",
  "100__match": "100% coincidencia",
  echanges_longue_distance: "Intercambios de larga distancia",
  matching_algorithmique_intelligent: "Coincidencia algorítmica inteligente",
  notre_algorithme_croise_les_informations_de_votre_profil_et_de_vos_recherches_pour_vous_proposer_toutes_les_annonces_de_logements_qui_correspondent_exactement_a_votre_demande_:
    "Nuestro algoritmo cruza la información de tu perfil y tus búsquedas para ofrecerte todos los anuncios de viviendas que se correspondan exactamente con tu solicitud.",
  matching_precis: "Coincidencia precisa",
  analyse_intelligente_de_vos_crit_res: "Análisis inteligente de tus criterios",
  gain_de_temps_dans_vos_recherches: "Ahorra tiempo en tu investigación",
  propositions_ultra_pertinentes: "Propuestas ultrarelevantes",
  habitants: "Residentes",
  destinations_europeennes: "Destinos europeos",
  decouvrez_les_merveilles_du_continent:
    "Descubre las maravillas del continente.",
  pays_actifs_sur_traveltrok: "Países activos en DONKEY TRAVEL",
  selectionner_un_pays: "Seleccione un país",
  union_europeenne: "Unión Europea",
  hors_union_europeenne: "Fuera de la Unión Europea",
  fiche_detaillee: "Ficha detallada",
  selectionnez_un_pays_dans_la_liste_ou_sur_la_carte_pour_decouvrir_climat__population_et_lieux_emblematiques_:
    "Selecciona un país de la lista o en el mapa para descubrir clima, población y lugares emblemáticos.",
  logements_actifs: "Vivienda activa",
  climat: "Clima",
  information_touristique: "Información Turística",
  lieux_emblematiques: "Lugares icónicos",
  gastronomie: "Gastronomía",
  dom_tom___outre_mer: "DOM-TOM / En el extranjero",
  villes_principales: "Ciudades principales",
  charte_officielle: "Carta oficial",
  confiance_mutuelle: "Confianza mutua",
  r_gles_claires: "Reglas claras",
  sanctions_applicables: "Sanciones aplicables",
  illustration_3d_des_engagements: "Ilustración 3D de compromisos",
  concept_3d_informations: "Imagen 3D de detalles.",
  principe_1: "Principio 1",
  v_racit__des_informations: "Veracidad de la información",
  profil__logement__photos_et_prix_doivent__tre_exacts_:
    "El perfil, el alojamiento, las fotos y los precios deben ser precisos.",
  concept_3d_respect_du_lieu: "Imagen 3D de respeto al lugar.",
  principe_2: "Principio 2",
  respect_du_lieu: "Respeto por el lugar.",
  aucune_f_te_et_z_ro_nuisance_pour_le_voisinage_:
    "Sin fiestas y sin molestias al barrio.",
  concept_3d_fiabilit__contractuelle: "Concepto de contrato en 3D",
  principe_3: "Principio 3",
  fiabilit__contractuelle: "Fiabilidad contractual",
  dates_bloqu_es___engagement_ferme__sauf_raison_valable_:
    "Fechas bloqueadas = compromiso firme, salvo que exista un motivo válido.",
  engagements_c_t__voyageur: "Compromisos del lado del pasajero",
  engagements_c_t__h_te: "Compromisos del lado anfitrión",
  annulations_et_reports: "Cancelaciones y aplazamientos",
  r_gle_op_rationnelle: "Regla operativa",
  check_list_d_part_voyageur: "Lista de verificación de salida",
  cuisine_et_vaisselle_propres: "Cocina y platos limpios.",
  sols_et_surfaces_rendus_propres: "Suelos y superficies limpios",
  linge_utilis__d_pos__selon_consigne:
    "Ropa usada depositada según instrucciones.",
  aucune_invitation_non_autoris_e_pendant_le_s_jour:
    "Sin invitaciones no autorizadas",
  _tat_final_du_logement_confirm__avec_photos:
    "Estado final de la vivienda confirmado",
  sanctions_en_cas_de_manquement: "Sanciones en caso de incumplimiento",
  ce_que_permet_traveltrok: "Lo que permite DONKEY TRAVEL",
  vous_pouvez_inscrire_autant_de_logements_que_vous_voulez_:
    "Puedes listar tantos alojamientos como quieras.",
  vous_pouvez__changer_autant_de_fois_que_vous_voulez_dans_l_ann_e_:
    "Canje sin límite de recurrencia durante el año.",
  chaque__change_repose_sur_un_contrat_clair_entre_deux_h_tes_:
    "Un contrato formal vincula oficialmente a los anfitriones y garantiza el éxito.",
  r_f_rences_de_bonnes_pratiques: "Referencias de mejores prácticas",
  un_club_s_rieux__une_communaut__durable:
    "Un club serio crea una comunidad duradera",
  retour_au_guide_complet: "Volver a la guía completa",
  carte_des_logements_traveltrok: "Mapa de alojamiento de DONKEY TRAVEL",
  points_logements: "Puntos de alojamiento",
  aucune_donnee_geolocalisee_pour_le_moment_:
    "No hay datos geolocalizados por el momento.",
  envie_d_entrer_dans_la_carte__: "¿Quieres aparecer en el mapa?",
  chargement_des_logements___: "Cargando vivienda...",
  la_date_d_arriv_e_est_requise: "Se requiere fecha de llegada",
  la_date_ne_peut_pas__tre_dans_le_pass_: "La fecha no puede ser en el pasado.",
  la_date_de_d_part_est_requise: "Se requiere fecha de salida",
  la_date_de_d_part_doit__tre_apr_s_l_arriv_e:
    "La fecha de salida debe ser posterior a la llegada.",
  le_message_doit_contenir_au_moins_10_caract_res:
    "El mensaje debe contener al menos 10 caracteres.",
  veuillez_corriger_les_erreurs_ci_dessus:
    "Por favor corrija los errores anteriores",
  une_erreur_est_survenue__veuillez_r_essayer_:
    "Ha ocurrido un error. Por favor inténtalo de nuevo.",
  paris__france: "París, Francia",
  mode_h_te: "Modo anfitrión",
  je_loue_quelques_semaines_par_an__le_mod_le_1eur___nuit_est_super_simple___expliquer_aux_voyageurs_:
    "Alquilo unas semanas al año. El modelo de 1EUR/noche es súper sencillo de explicar a los viajeros.",
  "37_nuits": "37 noches",
  lyon__france: "Lyon, Francia",
  mode_voyageur: "Moda viajera",
  la_r_servation_est_fluide__et_surtout_les_frais_sont_lisibles__je_compare_facilement_le_co_t_final_avant_de_confirmer_:
    "La reserva es sencilla y, sobre todo, las tarifas son legibles. Comparo fácilmente el coste final antes de confirmar.",
  "22_nuits": "22 noches",
  bordeaux__france: "Burdeos, Francia",
  "54_nuits": "54 noches",
  marseille__france: "Marsella, Francia",
  pro_multi_logements: "Pro multivivienda",
  avec_plusieurs_biens__la_version_pro_me_fait_gagner__norm_ment_de_temps_sur_le_calendrier_et_la_gestion_des_demandes_:
    "Con múltiples propiedades, la versión Pro me ahorra mucho tiempo en la programación y gestión de solicitudes.",
  "9_logements": "9 alojamientos",
  retours_utilisateurs: "Comentarios de los usuarios",
  des_retours_terrain_concrets: "Comentarios de campo concretos",
  des_voyageurs_et_h_tes_qui_veulent_une_location_plus_claire_et_plus_abordable_:
    "Viajeros y anfitriones que quieran un alquiler más claro y asequible.",
  activit_: "Actividad",
  _conomie_estim_e: "Ahorro estimado",
  profils_et_logements_v_rifi_s: "Perfiles y alojamientos verificados",
  exp_rience_location_simplifi_e: "Experiencia de alquiler simplificada",
  co_ts_transparents___la_nuit: "Costos transparentes por la noche",
  marquer_des_dates: "Marcar fechas",
  je_peux_accueillir: "Puedo acomodar",
  je_veux_partir: "Quiero irme",
  partir_et_accueillir: "Salida y bienvenida",
  accueillir: "Dar la bienvenida",
  partir: "Dejar",
  bloquer_les_dates: "Bloquear fechas",
  toujours_partir_et_accueillir: "Siempre vete y bienvenido",
  rendre_ce_logement_visible: "Hacer visible este alojamiento",
  rendre_ce_logement_invisible: "Haz que este alojamiento sea invisible",
  confirmation_visibilite_logement:
    "¿Está seguro de que desea cambiar la visibilidad de ESTE listado para otros miembros?",
  confirmer_activer_toujours_partir_accueillir:
    "Al activar este modo, se agregarán nuevas disponibilidades 'Salir y Bienvenido' para cubrir siempre los próximos 2 años a partir de hoy. Se sobrescribirán otras disponibilidades manuales.\n\n¿Estás seguro de que deseas continuar?",
  confirmer_desactiver_toujours_partir_accueillir:
    '¿Estás seguro de que deseas desactivar el modo "Salir y saludar siempre"?',
  details_de_l_adresse__optionnel_: "Detalles de la dirección (opcional)",
  rue_et_numero: "Calle y numero",
  ex__12_rue_de_la_paix: "Ej: 12 rue de la Paix",
  appartement_suite: "Apartamento, suite, etc.",
  ex__apt_4b: "Ej: Apto 4B",
  etage: "Piso",
  ex__3eme_sans_ascenseur: "Ej: 3º",
  code_d_acces: "Código de acceso (puerta/edificio)",
  ex__a1234: "Ej: A1234",
  ces_informations_ne_seront_partagees_qu_avec_les_voyageurs_confirmes:
    "Esta información detallada solo se comunicará a los miembros que tengan un intercambio confirmado con usted.",
  lits_doubles: "Camas dobles",
  lits_simples: "Camas individuales",
  canapes_lits: "Sofás cama",
  lits_bebes: "Cunas",
  amenity_cat_essentials: "Lo esencial",
  amenity_cat_kitchen: "Cocina y comidas",
  amenity_cat_bathroom: "Baño",
  amenity_cat_bedroom_laundry: "Dormitorio y ropa de cama",
  amenity_cat_entertainment: "Entretenimiento",
  amenity_cat_family: "Familia",
  amenity_cat_exterior: "Afuera",
  amenity_cat_features: "Características",
  amenity_cat_location: "Ubicación",
  amenity_cat_safety: "Seguridad",
  amenity_wifi: "Wifi",
  amenity_workspace: "Espacio de trabajo dedicado",
  amenity_ac: "Aire acondicionado",
  amenity_heating: "Calefacción",
  amenity_kitchen: "Cocina",
  amenity_refrigerator: "Refrigerador",
  amenity_microwave: "Microonda",
  amenity_oven: "Horno",
  amenity_dishwasher: "Lavavajillas",
  amenity_coffee_maker: "Maquina de cafe",
  amenity_kettle: "Pava",
  amenity_bathtub: "Bañera",
  amenity_hair_dryer: "Secador de pelo",
  amenity_shampoo: "Champú y gel de ducha",
  amenity_hot_water: "Agua caliente",
  amenity_washing_machine: "Lavadora",
  amenity_dryer: "Secadora",
  amenity_iron: "Hierro",
  amenity_hangers: "Perchas",
  amenity_bed_linens: "Ropa de cama incluida.",
  amenity_tv: "Televisión",
  amenity_game_console: "Consola de juegos",
  amenity_books_toys: "Libros y juguetes",
  amenity_sound_system: "Sistema de audio",
  amenity_high_chair: "Silla alta",
  amenity_baby_bath: "Baño bebe",
  amenity_travel_cot: "Cuna de viaje",
  amenity_changing_table: "Cambiador",
  amenity_patio: "Balcón o terraza",
  amenity_garden: "Jardín privado",
  amenity_bbq: "Parilla",
  amenity_outdoor_furniture: "Muebles de exterior",
  amenity_pool: "Piscina",
  amenity_hottub: "Jacuzzi",
  amenity_gym: "Gimnasia",
  amenity_fireplace: "Tubo de lámpara",
  amenity_breakfast: "Desayuno incluido",
  amenity_parking: "Aparcamiento gratuito",
  amenity_ev_charger: "Estación de carga de vehículos eléctricos",
  amenity_beachfront: "Acceso a la playa",
  amenity_ski_in_out: "Acceso a las pistas de esquí.",
  amenity_lake_access: "Acceso al lago",
  amenity_smoke_detector: "Detector de humo",
  amenity_first_aid: "Botiquín de primeros auxilios",
  amenity_fire_extinguisher: "Extintor",
  amenity_sauna: "Sauna",
  amenity_massage_chair: "Sillón de masaje",
  amenity_shower: "Ducha",
  amenity_home_cinema: "Cine en casa",
  amenity_ping_pong: "Mesa de ping-pong",
  amenity_forest_access: "Acceso al bosque",
  amenity_hiking_access: "Acceso al senderismo",
  compl_t_: "Terminado",
  l_adresse_doit_tre_localis_e_sur_la_carte:
    "La dirección debe estar ubicada en el mapa.",
  au_moins_3_photos_requises: "Se requieren al menos 3 fotos.",
  le_titre_doit_faire_au_moins_10_caract_res:
    "El título debe tener al menos 10 caracteres.",
  la_description_doit_faire_au_moins_50_caract:
    "La descripción debe tener al menos 50 caracteres.",
  s_lectionnez_au_moins_3_quipements: "Seleccione al menos 3 equipos",
  encore_quelques_d_tails_avant_de_publier:
    "Algunos detalles más antes de publicar.",
  votre_annonce_est_compl_t_e_x:
    "Su anuncio se completó al {{score}}%. Por favor completa los elementos que faltan para poder publicarlo:",
  compl_ter: "Completo",
  voici_comment_les_voyageurs_verront_votre_:
    "Así es como los viajeros verán tu anuncio.",
  photo: "Foto",
  afficher_toutes_les_photos: "Mostrar todas las fotos",
  h_t_par_vous: "• Anfitrión: usted",
  description: "Acerca de este alojamiento",
  votre_description_appara_tra_ici: "Tu descripción aparecerá aquí...",
  afficher_les_n__quipements_x: "Muéstrales{{count}}equipo",
  ajouter_une_date: "Añadir una fecha",
  aucun_montant_ne_vous_sera_d_bit_:
    "No se le cobrará ningún importe en este momento",
  demander: "Preguntar",
  enregistrer_et_quitter: "Guardar y salir",
  enregistrer_pour_plus_tard: "Guardar para más tarde",
  conseils_pour_des_photos_r_ussies: "Consejos para fotografías exitosas",
  privil_giez_le_format_paysage__1:
    "Elija el formato horizontal (16:9) para una mejor visualización.",
  prenez_vos_photos_de_jour__avec_:
    "Toma tus fotografías durante el día, con buena luz natural.",
  rangez_et_nettoyez_les_pi_ces_av:
    "Guarda y limpia las piezas antes de fotografiarlas.",
  mettez_en_avant_les_atouts_de_vo:
    "Resalte las ventajas de su alojamiento (vista, terraza, bonito salón, etc.).",
  donnez_un_titre___votre_annonce: "Dale un título a tu anuncio",
  un_titre_court_et_accrocheur_attirera_pl:
    "Un título breve y atractivo atraerá a más viajeros.",
  souhaite_visiter: "Me gustaría visitar",
  vous_propose_en_change: "Te ofrece a cambio",
  autres_logements: "Otro alojamiento",
  voir_le_logement: "Ver el alojamiento",
  votre_demande_titre: "Tu petición",
  votre_demande_soustitre:
    "Resumen de tus deseos de viaje y acompañantes para tus futuros intercambios.",
  compagnons_de_voyage: "Compañeros de viaje",
  voyage_avec_bebe: "Criaturas)",
  voyage_avec_animaux: "Mascotas",
  disponibilites_souhaitees: "Disponibilidad deseada",
  destinations_cibles: "Destinos objetivo",
  aucune_date_precisee: "No se ha especificado ninguna fecha de viaje.",
  aucune_destination_precisee:
    "No se ha especificado ningún destino de destino.",
  votre_demande_menu: "Tu petición",
  modifier_mon_profil: "Editar mi perfil",
  rayon_de: "Radio de{{km}}kilómetros",
  dates_flexibles_option: "Fechas flexibles",
  animaux_de_compagnie_details: "{{Count}}animal/animales",
  changer_d_annonce: "Cambiar anuncio",
  profil_du_voyageur: "Perfil de viajero",
  chambres_requises: "Habitaciones requeridas",
  animaux: "Animal(es)",
  duree_du_sejour_souhaitee: "Duración deseada de la estancia",
  combien_de_chambres_avez_vous_besoin__: "¿Cuantos dormitorios necesitas?",
  combien_de_b_b_s__: "¿Cuantos bebes?",
  combien__: "Cuánto ?",
  vos_animaux: "Tus animales",
  chien_s_: "Perros)",
  plus_de_30_nuits: "Más de 30 noches",
  "community.hero.badge": "Nuestra comunidad",
  "community.hero.title": "Únase a la red de alojamiento más auténtica",
  "community.hero.subtitle":
    "Comparte más que solo tu hogar. Descubra historias, conozca anfitriones apasionados y viaje con confianza.",
  "community.stats.members": "Miembros activos",
  "community.stats.countries": "Países representados",
  "community.stats.exchanges": "Intercambios realizados",
  "community.values.title": "¿Qué nos une?",
  "community.values.trust.title": "Confianza absoluta",
  "community.values.trust.desc":
    "Cada miembro es un anfitrión verificado, lo que garantiza el respeto mutuo de las instalaciones.",
  "community.values.sharing.title": "Compartir y reuniones",
  "community.values.sharing.desc":
    "La oportunidad de crear vínculos con locales de toda Europa.",
  "community.values.savings.title": "Ahorros reales",
  "community.values.savings.desc":
    "Viaje más a menudo, más lejos y manteniendo su presupuesto.",
  "community.testimonials.title": "Historias de miembros",
  "community.cta.title": "¿Listo para ser parte de la aventura?",
  "community.cta.button": "Hazte miembro hoy",
  "blog.hero.badge": "Nuestro Blog",
  "blog.hero.title": "Inspiración y consejos",
  "blog.hero.subtitle":
    "Descubre historias de viajes, consejos para preparar tu alojamiento y novedades del club.",
  "blog.categories.all": "Todos los artículos",
  "blog.categories.tips": "Consejos para anfitriones",
  "blog.categories.inspiration": "Inspiración para viajar",
  "blog.categories.news": "Noticias",
  "blog.empty": "No hay artículos por el momento. ¡Vuelve pronto!",
  "help.hero.badge": "Centro de ayuda",
  "help.hero.title": "¿Cómo podemos ayudarte?",
  "help.hero.subtitle":
    "Encuentre respuestas rápidas o comuníquese con nuestro equipo de soporte.",
  "help.search.placeholder": "Busca una respuesta...",
  "help.categories.account.title": "Cuenta y perfil",
  "help.categories.account.desc":
    "Gestiona tu información, contraseñas y preferencias.",
  "help.categories.exchanges.title": "Cambios y Reservas",
  "help.categories.exchanges.desc":
    "Cómo ofrecer, aceptar o cancelar un intercambio.",
  "help.categories.trust.title": "Confianza y seguridad",
  "help.categories.trust.desc":
    "Contratos, verificación y protección de viviendas.",
  "help.faq.title": "Preguntas frecuentes",
  "help.contact.cta": "¿No encontraste tu respuesta?",
  "help.contact.button": "Contáctenos",
  "careers.hero.badge": "Únete al equipo",
  "careers.hero.title": "Construyamos el futuro de los viajes",
  "careers.hero.subtitle":
    "Buscamos personas apasionadas para redefinir la forma en que los huéspedes viajan en Europa.",
  "careers.values.title": "Nuestros Valores",
  "careers.values.trust.title": "Humanidad y confianza",
  "careers.values.remote.title": "Teletrabajo flexible",
  "careers.values.impact.title": "Impacto real",
  "careers.openings.title": "Posiciones abiertas",
  "careers.openings.empty":
    "No hay puestos abiertos actualmente. ¡No dudes en enviar una solicitud espontánea!",
  "careers.apply.title": "Aplicación espontánea",
  "careers.apply.desc":
    "Envía tu CV y ​​cuéntanos cómo puedes ayudar a Donkey Travel.",
  "careers.apply.button": "Enviar mi solicitud",
  "contact.hero.badge": "Contacto",
  "contact.hero.title": "Estamos aquí para ti",
  "contact.hero.subtitle":
    "¿Una pregunta, sugerencia o problema? Nuestro equipo está listo para escucharte.",
  "contact.form.name": "Su nombre",
  "contact.form.email": "Tu correo electrónico",
  "contact.form.subject": "Asunto de tu mensaje",
  "contact.form.message": "Tu mensaje...",
  "contact.form.send": "enviar mensaje",
  "contact.info.title": "Información útil",
  "contact.info.email": "contacto@burro.travel",
  "contact.info.address": "Valle del Alto Somme, Picardía, Francia",
  "contact.info.hours": "Lunes a viernes: 9:00 a. m. - 6:00 p. m.",
  activez_votre_abonnement: "Activa tu suscripción",
  finalisez_votre_inscription: "Finaliza tu registro",
  _changes_illimit_s_en_europe: "Intercambios ilimitados en Europa",
  validit___1_an: "Validez: 1 año",
  paiement_100__s_curis__par_paypal: "Pago 100% seguro por PayPal",
  me_d_connecter_et_revenir_plus_tard: "Cerrar sesión y volver más tarde",
  erreur_lors_de_la_validation_du_paiement_sur_n:
    "Error al validar el pago en nuestros servidores.",
  le_paiement_n_a_pas_pu__tre_valid_: "No se pudo validar el pago.",
  une_erreur_inconnue_est_survenue_lors_du_paiem:
    "Se produjo un error desconocido durante el pago.",
  impossible_d_initialiser_paypal__v_rifiez_vot:
    "No se puede inicializar PayPal. Comprueba tu conexión.",
  donn_es_personnelles: "Datos personales",
  rejoignez_notre_communaut__et_r_servez_un_logement:
    "Únase a nuestra comunidad y reserve alojamiento en {{city}} con tarifas fijas claras y seguro incluido.",
  bienvenue: "Bienvenido",
  code_promo_applique_avec_succes: "¡Código promocional aplicado con éxito!",
  cible: "Objetivo",
  propose: "Proponer",
  "1_sens": "1 sentido",
  "2_sens": "2 sentidos",
  ils_veulent_visiter_votre_region_br_c_est_a_vous:
    "Quieren visitar tu zona.<br />¡Depende de ti descubrir dónde viven!",
  ils_cherchent_chez_vous_et_br_ils_habitent_la_ou:
    "¡Te están buscando Y<br />¡viven donde tú quieres ir!",
  comment_ca_marche: "¿Cómo funciona?",
  comprendre_les_differents_types_de_matching:
    "Comprender los diferentes tipos de emparejamiento",
  match_reciproque: "Partido recíproco",
  details_de_la_demande: "Solicitar detalles",
  souhaite_venir_dans_votre_secteur: "Me gustaría ir a tu zona:",
  peut_vous_accueillir: "Puede acomodarle:",
  souhaite_visiter_dans_un_rayon:
    "Quiere visitar <strong>{{city}}</strong> en un radio de <strong>{{radius}} km</strong>, su alojamiento coincide con su búsqueda.",
  souhaite_visiter_ville:
    "Me gustaría visitar <strong>{{city}}</strong>, su alojamiento coincide con su búsqueda.",
  a_besoin_de_chambres: "Necesita {{count}} habitación(es).",
  comparateur_de_valeur: "Comparador de valores",
  ecart: "Brecha",
  code_promo_invalide: "Código promocional inválido",
  erreur_verification_code: "Error al verificar el código",
  vous_avez_un_code_promo: "¿Tienes un código promocional?",
  entrez_votre_code: "INTRODUCE TU CÓDIGO",
  appliquer: "Aplicar",
  importation_r_ussie_:
    "¡Importación exitosa! Su información ha sido precompletada.",
  erreur_lors_de_l_importation: "Error durante la importación:",
  d_crivez_ce_qui_rend_votre_logement_uniq:
    "Describe lo que hace que tu hogar sea único...",
  mettez_en_avant_les_points_forts___votre:
    "Destaca los puntos fuertes de tu alojamiento.",
  lien_annonce_airbnb_1: "Enlace a tu anuncio de Airbnb",
  importation___: "Importar...",
  importer_l_annonce: "Importar anuncio",
  renseignez_le_lien_de_votre_annonce_pou_:
    "Ingrese el enlace a su anuncio. Puede importar los detalles automáticamente para ahorrar tiempo.",
  lien_calendrier_airbnb: "Enlace al calendario (iCal)",
  nous_utiliserons_ce_lien_pour_synchroni:
    "Usaremos este enlace para sincronizar su disponibilidad.",
  entrer_en_contact: "Ponte en contacto",
  attention___risque__lev__de_d_pendance_aux_voyages_gratuits__:
    "Advertencia: ¡alto riesgo de adicción a los viajes gratis!",
};
